
export const CODE_SYSTEMS = {
    'LOINC'     : { url: 'http://loinc.org'                            },
    'SNOMED-CT' : { url: 'http://snomed.info/sct'                      },
    'RxNorm'    : { url: 'http://www.nlm.nih.gov/research/umls/rxnorm' },
    'CVX'       : { url: 'http://hl7.org/fhir/sid/cvx'                 },
    'NUBC'      : { url: 'http://www.nubc.org/patient-discharge'       },
    'UMLS'      : { url: 'http://uts.nlm.nih.gov/metathesaurus'        }
};